import { Lock } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="privacy-page">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Lock className="h-5 w-5 text-primary" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Política de Privacidade</h1>
      </div>

      <div className="prose prose-sm max-w-none text-muted-foreground space-y-6">
        <p className="text-xs text-muted-foreground/70">Última atualização: Junho de 2026</p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">1. Introdução</h2>
          <p>A VENDA DE GARAGEM está comprometida com a proteção da privacidade e dos dados pessoais de seus usuários, em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD — Lei nº 13.709/2018). Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">2. Dados Coletados</h2>
          <p>Coletamos os seguintes tipos de dados:</p>
          <div className="space-y-2">
            <h3 className="text-base font-medium text-foreground">2.1 Dados fornecidos pelo usuário</h3>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Nome, e-mail, telefone e localização (cidade/estado) durante o cadastro;</li>
              <li>Chave PIX e dados bancários para recebimento de pagamentos;</li>
              <li>Informações de produtos anunciados (fotos, vídeos, descrições, preços);</li>
              <li>Mensagens trocadas pelo sistema de chat da plataforma.</li>
            </ul>
            <h3 className="text-base font-medium text-foreground mt-3">2.2 Dados coletados automaticamente</h3>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Endereço IP, tipo de navegador e sistema operacional;</li>
              <li>Dados de navegação e interação com a plataforma;</li>
              <li>Cookies e tecnologias semelhantes para funcionamento e análise.</li>
            </ul>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">3. Finalidade do Tratamento</h2>
          <p>Utilizamos seus dados pessoais para as seguintes finalidades:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><strong>Prestação do serviço:</strong> Criar e gerenciar sua conta, processar transações, intermediar comunicações entre compradores e vendedores;</li>
            <li><strong>Segurança:</strong> Prevenir fraudes, verificar identidade e garantir a integridade das transações;</li>
            <li><strong>Comunicação:</strong> Enviar notificações sobre transações, atualizações da plataforma e comunicados importantes;</li>
            <li><strong>Melhoria do serviço:</strong> Analisar padrões de uso para aprimorar a experiência do usuário;</li>
            <li><strong>Obrigações legais:</strong> Cumprir exigências regulatórias e legais aplicáveis.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">4. Base Legal para o Tratamento</h2>
          <p>O tratamento dos seus dados pessoais é realizado com base nas seguintes hipóteses previstas na LGPD:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><strong>Consentimento:</strong> Para cookies não essenciais e comunicações de marketing;</li>
            <li><strong>Execução de contrato:</strong> Para a prestação dos serviços da plataforma;</li>
            <li><strong>Legítimo interesse:</strong> Para prevenção de fraudes e melhoria dos serviços;</li>
            <li><strong>Obrigação legal:</strong> Para cumprimento de determinações legais e regulatórias.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">5. Compartilhamento de Dados</h2>
          <p>Seus dados podem ser compartilhados com:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><strong>Processadores de pagamento:</strong> Para efetuar e verificar transações financeiras (ex: OASIS Exchange);</li>
            <li><strong>Outros usuários:</strong> Informações públicas do perfil e dados necessários para a conclusão de transações;</li>
            <li><strong>Autoridades competentes:</strong> Quando exigido por lei ou ordem judicial;</li>
            <li><strong>Prestadores de serviço:</strong> Que auxiliam na operação da plataforma, sob contratos de confidencialidade.</li>
          </ul>
          <p>A VENDA DE GARAGEM <strong>não vende</strong> dados pessoais a terceiros.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">6. Armazenamento e Segurança</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Os dados são armazenados em servidores seguros com criptografia e controles de acesso;</li>
            <li>Senhas são armazenadas de forma criptografada (hash) e nunca em texto puro;</li>
            <li>Utilizamos protocolos HTTPS para todas as comunicações;</li>
            <li>Realizamos monitoramento contínuo para identificar e mitigar ameaças.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">7. Seus Direitos (LGPD)</h2>
          <p>Conforme a LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><strong>Acesso:</strong> Solicitar uma cópia dos seus dados pessoais armazenados;</li>
            <li><strong>Correção:</strong> Solicitar a correção de dados incompletos ou incorretos;</li>
            <li><strong>Eliminação:</strong> Solicitar a exclusão dos seus dados pessoais;</li>
            <li><strong>Portabilidade:</strong> Solicitar a exportação dos seus dados em formato legível;</li>
            <li><strong>Revogação do consentimento:</strong> Retirar o consentimento para o tratamento de dados a qualquer momento;</li>
            <li><strong>Oposição:</strong> Se opor ao tratamento de dados quando baseado em legítimo interesse.</li>
          </ul>
          <p>Para exercer esses direitos, acesse a seção <strong>&ldquo;Meus Dados&rdquo;</strong> no seu perfil ou entre em contato pelo e-mail: <a href="mailto:vendagsac@gmail.com" className="text-primary hover:underline font-medium">vendagsac@gmail.com</a></p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">8. Cookies</h2>
          <p>A plataforma utiliza cookies para:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><strong>Cookies essenciais:</strong> Necessários para o funcionamento da plataforma (autenticação, preferências);</li>
            <li><strong>Cookies analíticos:</strong> Para entender como os usuários interagem com a plataforma;</li>
            <li><strong>Cookies de preferência:</strong> Para salvar configurações e personalizar a experiência.</li>
          </ul>
          <p>Você pode gerenciar suas preferências de cookies através do banner exibido ao acessar a plataforma pela primeira vez.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">9. Retenção de Dados</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Dados de conta são mantidos enquanto a conta estiver ativa;</li>
            <li>Dados de transações são mantidos pelo período exigido pela legislação fiscal e tributária brasileira;</li>
            <li>Após a exclusão da conta, dados pessoais são eliminados em até 30 dias, salvo obrigações legais de retenção.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">10. Alterações nesta Política</h2>
          <p>Esta Política de Privacidade pode ser atualizada periodicamente. As alterações serão comunicadas através da plataforma e/ou por e-mail. Recomendamos a revisão periódica deste documento.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">11. Contato e Encarregado de Dados (DPO)</h2>
          <p>Para questões relacionadas à privacidade e proteção de dados, entre em contato:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>E-mail: <a href="mailto:vendagsac@gmail.com" className="text-primary hover:underline font-medium">vendagsac@gmail.com</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
}
